import React, { useState, useRef } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress'; 
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
// import verifyToken from '../HelperFx/verifyJwt.js';
import axios from 'axios';
import { base64backendtoken } from '../HelperFx/datalinks.js';


const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;

const ChangePassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  

  // const jwttoken = sessionStorage.getItem('authToken');
  // const {custName,userName, password} = verifyToken(jwttoken);



  const [formData, setFormData] = useState({
    username: location.state?.email ||'',
    otp: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorsMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
  
  const [open, setOpen] = useState(false);

  const handleClick = () => setOpen(true);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const handleTogglePasswordVisibility = () => setShowPassword((prev) => !prev);
  const handleTogglePasswordConfirmVisibility = () => setShowPasswordConfirm((prev) => !prev);
  const handleToggleOldPasswordVisibility = () => setShowOldPassword((prev) => !prev);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (formData.confirmPassword !== formData.newPassword) {
        setErrorMsg('Passwords do not match');
        handleClick();
        setLoading(false); // Stop loader if validation fails
        return;
      }

    try {
      const response = await axios.post(
        `${REACT_EXPRESS}/changePwd`, 
        formData
        // {
        //   headers: {
        //     Authorization: `Basic ${base64backendtoken}`,
        //   },
        // }
      );
      const { success, message } = response.data;

      if (success) {
        setSuccessMsg("Password Change successfully! Redirecting to Login page");
        setOpen(true);
        setTimeout(() => {
          console.log('Redirecting to change password');
           navigate('/signin');
          }, 4000);
         // Redirect to dashboard after success
      } else {
        setErrorMsg(message);
        handleClick();
      }
    } catch (error) {
      setErrorMsg(error.response?.data?.message || 'Something went wrong');
      handleClick();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 2,
      }}
    >
      <Typography variant="h5" gutterBottom>
        Change Your Password
      </Typography>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
          maxWidth: 400,
        }}
      >
        <FormControl>
          <FormLabel htmlFor="otp" sx={{ fontSize: '0.875rem' }}>Reset Code</FormLabel>
          <TextField
            id="otp"
            name="otp"
            type={showOldPassword ? 'text' : 'password'}
            placeholder="Enter the Reset Code"
            value={formData.otp}
            onChange={handleChange}
            size="small"
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleToggleOldPasswordVisibility}>
                    {showOldPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel htmlFor="newPassword" sx={{ fontSize: '0.875rem' }}>New Password</FormLabel>
          <TextField
            id="newPassword"
            name="newPassword"
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter new password"
            value={formData.newPassword}
            onChange={handleChange}
            size="small"
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePasswordVisibility}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel htmlFor="username" sx={{ fontSize: '0.875rem' }}>Confirm Password</FormLabel>
          <TextField
            id="confirmPassword"
            name="confirmPassword"
            type={showPasswordConfirm ? 'text' : 'password'}
            placeholder="Confirm New Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            size="small"
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePasswordConfirmVisibility}>
                    {showPasswordConfirm ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <Button type="submit" variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Change Password'}
        </Button>
      </Box>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={successMsg||errorsMsg}
        action={
          <IconButton size="small" color="inherit" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </Box>
  );
};

export default ChangePassword;
